module.exports = __webpack_public_path__ + "mstile-70x70.png?890f23b46ac4f675b4ba93650dc3492f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mstile-70x70.png
// module id = 234
// module chunks = 0